
import { FormItem } from '@/model/form/FormItem';
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FormSelector extends Vue {
    @Prop(String) readonly id!: string;

    @Prop(String) readonly label!: string;

    @Prop() options!: FormItem[] | unknown;

    @Prop({ default: false, type: Boolean }) required!: boolean;

    @Prop({ default: false, type: Boolean }) loading!: boolean;

    @Prop({ default: null, type: Boolean }) readonly state!: boolean | null;

    @Prop() defaultValue?: string;

    @Prop({ default: false, type: Boolean }) hasEmptyOption!: boolean;

    @Prop(String) emptyOptionText!: string;

    @Prop({ default: false, type: Boolean }) disabled!: boolean;

    @ModelSync('selected', 'change', { type: [Object, String, Number] })
    readonly selectedValue!: unknown;
}
